







import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import { PeriodicElement, BonusPeriodicElement } from '../data';

import Element from './Element.vue';
import Header from './Header.vue';

@Component({
  components: {
    Header,
    Element,
  },
  methods: mapActions(['visitElement']),
  computed: { ...mapGetters(['selectedElement']) },

  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      if (!vm.selectedElement) {
        vm.$router.replace('/404');
      } else {
        vm.visitElement({
          element: vm.selectedElement.element,
          selected: true,
        });
      }
    });
  },
})
export default class SelectedElement extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SelectedElement.vue